import { Fragment } from 'react';
import { useSelector } from 'react-redux';

const AssetsReportListView = () => {
    const { account_trial_balance_rpt_list } = useSelector((state) => state.accounts);
        const { menu_list } = useSelector((state) => state?.software);
        useSelector((state) => state.accounts);
    const Org_Details = menu_list?.structure;
    // Calculate totals
    const totals = {
        countpcs: 0,
        totpurchamt: 0,
        prvamt: 0,
        currpurchamt: 0,
        cursaleamt: 0,
        totamt: 0,
        deprecamt: 0,
        netamt: 0
    };

    // Group data by sglsn for rowspan calculation
    const groupedData = {};
    account_trial_balance_rpt_list?.results?.forEach((row, i) => {
        // Calculate totals
        totals.countpcs += row.countpcs || 0;
        totals.totpurchamt += row.totpurchamt || 0;
        totals.prvamt += row.prvamt || 0;
        totals.currpurchamt += row.currpurchamt || 0;
        totals.cursaleamt += row.cursaleamt || 0;
        totals.totamt += row.totamt || 0;
        totals.deprecamt += row.deprecamt || 0;
        totals.netamt += row.netamt || 0;

        // Group by sglsn
        if (!groupedData[row.sglsn]) {
            groupedData[row.sglsn] = [];
        }
        groupedData[row.sglsn].push(row);
    });

    // Flatten the grouped data with rowspan info
    const flattenedData = [];
    Object.keys(groupedData).forEach(sglsn => {
        const group = groupedData[sglsn];
        group.forEach((row, index) => {
            flattenedData.push({
                ...row,
                sglsnRowspan: index === 0 ? group.length : 0,
                subLedgerRowspan: index === 0 ? group.length : 0
            });
        });
    });

    return (
        <Fragment>
            <div className='bg-white rounded-md p-2 border border-slate300 dark:border-slate800 dark:bg-slate900'>
                <div className="relative overflow-x-auto overflow-y-auto h-[80vh]">
                    <table className='w-full'>
                        <thead className="text-sm text-left rtl:text-right text-gray-100 whitespace-nowrap scroll-x-auto dark:text-gray-400 rounded w-full">
                            <tr className="text-[13px] text-gray700 bg-slate100 top-0 z-50 sticky capitalize border-b dark:bg-slate900 dark:text-gray-400 font-public-sans">
                                <th rowSpan={2} scope="col" align='center' className="px-2 py-0.5 border dark:border-slate600 w-10">S.N.</th>
                                <th rowSpan={2} scope="col" align='center' className="px-2 py-0.5 border dark:border-slate600">GLID</th>
                                <th rowSpan={2} scope="col" align='center' className="px-2 py-0.5 border dark:border-slate600">Sub Ledger</th>
                                <th rowSpan={2} scope="col" align='center' className="px-2 py-0.5 border dark:border-slate600">Particular</th>
                                <th rowSpan={2} scope="col" align='center' className="px-2 py-0.5 border dark:border-slate600">Code</th>
                                <th rowSpan={2} scope="col" align='center' className="px-2 py-0.5 border dark:border-slate600">Count Pic</th>
                                <th rowSpan={2} scope="col" align='center' className="px-2 py-0.5 border dark:border-slate600">Purchase Amt</th>
                                <th rowSpan={2} scope="col" align='center' className="px-2 py-0.5 border dark:border-slate600">Prev Year Pur Amt</th>
                                <th rowSpan={2} scope="col" align='center' className="px-2 py-0.5 border dark:border-slate600">Current Year Pur Amt</th>
                                <th rowSpan={2} scope="col" align='center' className="px-2 py-0.5 border dark:border-slate600">Current Year Sel Amt</th>
                                <th rowSpan={2} scope="col" align='center' className="px-2 py-0.5 border dark:border-slate600">Total Amount</th>
                                <th colSpan={2} scope="col" align='center' className="px-2 py-0.5 border dark:border-slate600">Depression Rate</th>
                                <th rowSpan={2} scope="col" align='center' className="px-2 py-0.5 border dark:border-slate600">Total Amount</th>
                            </tr>
                            <tr className="text-[13px] text-gray700 bg-slate100 top-0 z-50 sticky capitalize border-b dark:bg-slate900 dark:text-gray-400 font-public-sans">
                                <th scope="col" align='center' className="px-2 py-0.5 border dark:border-slate600 w-10">%</th>
                                <th scope="col" align='center' className="px-2 py-0.5 border dark:border-slate600">Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {flattenedData.map((row, i) => {
                                const code = row?.particularname?.split(" ").map(item=>item.charAt(0)).join("");
                                return(
                                <tr key={i} className="bg-white text-[12px] text-slate800 dark:text-slate400 dark:bg-slate800 border-b font-public-sans dark:border-slate700 hover:bg-slate100 hover:dark:bg-slate700">
                                    {row.sglsnRowspan > 0 ? (
                                        <td rowSpan={row.sglsnRowspan} className="px-2 py-0.5 border dark:border-slate600 w-10">
                                            {row.sglsn}
                                        </td>
                                    ) : null}
                                    <td className="px-2 py-0.5 border dark:border-slate600 w-10">{row.glid}</td>
                                    {row.subLedgerRowspan > 0 ? (
                                        <td rowSpan={row.subLedgerRowspan} className="px-2 py-0.5 border dark:border-slate600">
                                            {row.sub_ledg_name}
                                        </td>
                                    ) : null}
                                    <td className="px-2 py-0.5 border dark:border-slate600">{row?.particularid}. {row.particularname}</td>
                                    <td className="px-2 py-0.5 border dark:border-slate600 uppercase">{`${Org_Details?.short_name}/${row.glid}/${row.particularid}/${code}`}</td>
                                    <td className="px-2 py-0.5 border dark:border-slate600">{row.countpcs}</td>
                                    <td align='end' className="px-2 py-0.5 border dark:border-slate600">{Number(row.totpurchamt).toFixed(2)}</td>
                                    <td align='end' className="px-2 py-0.5 border dark:border-slate600">{Number(row.prvamt).toFixed(2)}</td>
                                    <td align='end' className="px-2 py-0.5 border dark:border-slate600">{Number(row.currpurchamt).toFixed(2)}</td>
                                    <td align='end' className="px-2 py-0.5 border dark:border-slate600">{Number(row.cursaleamt).toFixed(2)}</td>
                                    <td align='end' className="px-2 py-0.5 border dark:border-slate600">{Number(row.totamt).toFixed(2)}</td>
                                    <td align='end' className="px-2 py-0.5 border dark:border-slate600">{Number(row.deprate).toFixed(2)}</td>
                                    <td align='end' className="px-2 py-0.5 border dark:border-slate600">{Number(row.deprecamt).toFixed(2)}</td>
                                    <td align='end' className="px-2 py-0.5 border dark:border-slate600">{Number(row.netamt).toFixed(2)}</td>
                                </tr>
                            )})}
                            
                            {/* Totals row */}
                            <tr className="bg-slate-100 text-[12px] text-slate-800 dark:text-slate-400 dark:bg-slate-700 border-b font-public-sans dark:border-slate-600 font-bold">
                                <td colSpan="4" className="px-2 py-0.5 border dark:border-slate-600 text-right">Total:</td>
                                <td align='end' className="px-2 py-0.5 border dark:border-slate-600">{totals.countpcs}</td>
                                <td align='end' className="px-2 py-0.5 border dark:border-slate-600">{Number(totals.totpurchamt).toFixed(2)}</td>
                                <td align='end' className="px-2 py-0.5 border dark:border-slate-600">{Number(totals.prvamt).toFixed(2)}</td>
                                <td align='end' className="px-2 py-0.5 border dark:border-slate-600">{Number(totals.currpurchamt).toFixed(2)}</td>
                                <td align='end' className="px-2 py-0.5 border dark:border-slate-600">{Number(totals.cursaleamt).toFixed(2)}</td>
                                <td align='end' className="px-2 py-0.5 border dark:border-slate-600">{Number(totals.totamt).toFixed(2)}</td>
                                <td align='end' className="px-2 py-0.5 border dark:border-slate-600"></td>
                                <td align='end' className="px-2 py-0.5 border dark:border-slate-600">{Number(totals.deprecamt).toFixed(2)}</td>
                                <td align='end' className="px-2 py-0.5 border dark:border-slate-600">{Number(totals.netamt).toFixed(2)}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </Fragment>
    )
}

export default AssetsReportListView